import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=0795a6ae&scoped=true&"
import script from "./ChatThread.vue?vue&type=script&lang=js&"
export * from "./ChatThread.vue?vue&type=script&lang=js&"
import style0 from "./ChatThread.vue?vue&type=style&index=0&id=0795a6ae&prod&scoped=true&lang=css&"
import style1 from "./ChatThread.vue?vue&type=style&index=1&id=0795a6ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795a6ae",
  null
  
)

export default component.exports